import {FilterType} from "@studyportals/omnisearch-interfaces";
import {FilterMapper} from "@app/routing/mappers/FilterMapper";
import {areasAll} from "@studyportals/static-domain-data/areas/areas";
import {areaGetPath} from "@studyportals/static-domain-data/areas/area-get-path";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";
import { CountryFilterMapper } from "./CountryFilterMapper";

export class AreaFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.AREA;
	public isMultiSelect = true;
	private static instance: AreaFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [];
	private countryAreas : {id: string, countryId:string} [] = [];

	public static getInstance(): AreaFilterMapper {
		if (!AreaFilterMapper.instance) {
			AreaFilterMapper.instance = new AreaFilterMapper();
		}
		return AreaFilterMapper.instance;
	}

	private constructor() {
		super();

		const typedAreas = areasAll as unknown as { id: number | string; name: string, countryId:string }[];

		for (const area of typedAreas) {
			const virtualPath = areaGetPath(area.id.toString()).split('/')[1];

			if (virtualPath) {
				this.values.push({
					id: area.id.toString(),
					virtualPath,
					name: area.name
				});
				this.countryAreas.push({
					id: area.id.toString(),
					countryId: area.countryId
				});
			}
		}
	}

	public getCountryIsoByAreaId(areaId: string): string | undefined {
		const countryId = this.countryAreas.find((area) => area.id === areaId)?.countryId;
		const countryMapper =  CountryFilterMapper.getInstance();

		return countryMapper.getIsoByCountryId(countryId ?? '');
	}
}
